import { useCallback, useEffect, useRef } from 'react'

function resize(el: HTMLTextAreaElement) {
  const prev = el.style.height
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
  if (el.style.height !== prev) {
    window.dispatchEvent(new Event('resize'))
  }
}

export function autosizeRef(el: HTMLTextAreaElement | null) {
  if (el) {
    el.style.overflow = 'hidden'
    el.style.resize = 'none'
    resize(el)
  }
}

export function useAutosizeTextarea(value: string) {
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (ref.current) resize(ref.current)
  }, [value])

  const setRef = useCallback((el: HTMLTextAreaElement | null) => {
    ref.current = el
    if (el) {
      el.style.overflow = 'hidden'
      el.style.resize = 'none'
      resize(el)
    }
  }, [])

  return setRef
}

export function useAutosizeAll(selector: string, deps: any[]) {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLTextAreaElement>(selector)
    els.forEach((el) => {
      el.style.overflow = 'hidden'
      el.style.resize = 'none'
      resize(el)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
